export const startProgress = (cart) => {
  return (dispatch, _) => {
    dispatch({ type: 'GA/START', payload: { cart: cart } });
  };
};

export const trackProgress = (step) => {
  return (dispatch, getState) => {
    let state = getState();

    dispatch({ type: 'GA/PROGRESS', payload: { step: step, state: state } });
  };
};

export const trackSelection = () => {
  return (dispatch, getState) => {
    let state = getState();

    dispatch({ type: 'GA/SET_SHIPPING_METHOD', payload: { state: state } });
  };
};

export const trackTransactionSuccess = (transactionId) => {
  return (dispatch, getState) => {
    let state = getState();

    dispatch({ type: 'GA/TRANSACTION_SUCCESS', payload: { state: state, transactionId: transactionId } });
  };
};
